import { authHeaders } from '@/utils/authToken';
import type { DriverProfile } from '@/types';

export const profileService = {
  async get(): Promise<DriverProfile> {
    const res = await fetch('/api/profile', { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async update(updates: Partial<DriverProfile>): Promise<DriverProfile> {
    const res = await fetch('/api/profile', {
      method: 'PUT',
      headers: await authHeaders(),
      body: JSON.stringify(updates),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async getOnboardingStep(): Promise<{ onboarding_step: string; onboarding_completed_at: string | null }> {
    const res = await fetch('/api/profile/onboarding', { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async updateOnboardingStep(step: string): Promise<DriverProfile> {
    const res = await fetch('/api/profile/onboarding', {
      method: 'PUT',
      headers: await authHeaders(),
      body: JSON.stringify({ step }),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },
};
